import React from 'react';
import MuiPagination, { PaginationProps } from '@material-ui/lab/Pagination';
import styled from 'styled-components';

const CustomPagination = styled(MuiPagination)`
  .MuiPaginationItem-page.Mui-selected {
    background-color: transparent;
    border: 1px solid ${props => props.theme.paletteDefault.primary.main};
  }
  .MuiPaginationItem-root {
    min-width: auto;
  }
  ul li:last-child {
    & svg {
      display: none;
    }
    background-image: url('/asset/v2/arrow_right.svg');
    background-repeat: no-repeat;
    width: 12px;
    height: 12px;
    margin-left: 4px;
  }
  ul li:first-child {
    & svg {
      display: none;
    }
    background-image: url('/asset/v2/arrow_left.svg');
    background-repeat: no-repeat;
    width: 12px;
    height: 12px;
    margin-right: 8px;
  }
`;

export interface IPagination extends PaginationProps {}

const Pagination: React.FC<IPagination> = ({ children, ...props }) => {
  return <CustomPagination {...props}>{children}</CustomPagination>;
};

export default Pagination;
